import {React, useState, useEffect, useRef, Fragment} from 'react';

import styles from './rosters.module.css'

import constants from '../../../constants.js'
import utils from '../../../utils/utils.js'
import api from '../../../routes/api.js'

import { useApiProvider } from '../../../providers/ApiProvider.js';
import { useLeagueTypeProvider } from '../../../providers/LeagueTypeProvider';

import SelectTable from '../../common/SelectTable/SelectTable.js';
import Table from '../../common/Table/Table.js';

const Rosters = ({selectedDivision,
                  loggedInUser,
                  homeTeam, awayTeam,
                  players, setPlayers,
                  genderPlayers, setGenderPlayers,
                  isLineupLocked,
                  dirtyGames, updateDirtyGames,
                  isSwapping, setIsSwapping,
                  swappingPlayer, setSwappingPlayer,
                  handleCleanSwap, matchupTime, matchupEnded}) => {
  
  const { setDialog, setIsLoading } = useApiProvider();
  const { leagueType } = useLeagueTypeProvider();

  const countSelectedRows = (rows) => {
    let selected = 0;
    rows.forEach((r) => {
      if ( r.selected ) selected++;
    })
    return selected;
  }

  /* e: dom node for check box in table*/
  /* row: row in male/femalePlayers to update*/
  /* I know this is slop, sue me */
  const onRowSelect = (e, row) => {

    const newPlayers = leagueType === constants.pages.genderLeagues ? {...genderPlayers} : {...players}
    let keyToUpdate = ""

    if (leagueType === constants.pages.genderLeagues) {
      if (row[constants.teamId] == homeTeam.id) {
        keyToUpdate = constants.homePlayers;
      } else {
        keyToUpdate = constants.awayPlayers;
      }
    }
    else {
      // Get which table we are updating (note uppercase male check)
      if (row[constants.gender] == constants.Male) {
        if (row[constants.teamId] == homeTeam.id) {
          keyToUpdate = constants.homeMales;
        } else {
          keyToUpdate = constants.awayMales;
        }
      }
      // Note uppercasae female check
      else if (row[constants.gender] == constants.Female) {
        if (row[constants.teamId] == homeTeam.id) {
          keyToUpdate = constants.homeFemales;
        } else {
          keyToUpdate = constants.awayFemales;
        }
      }
    }
    

    const tablePlayers = newPlayers[keyToUpdate];
    // Select the player
    tablePlayers.map((p) => {
      if (p[constants.playerId] == row[constants.playerId]) {
        p.selected = e.currentTarget.checked;
      }
    });
    
    // If we are now at the max rows, disable all of the un-checked boxes
    const selectedRows = countSelectedRows(tablePlayers);
    // For gender leagues, allow 12 players instead of the general 6
    const maxPlayers = leagueType === constants.pages.genderLeagues ? constants.maxGenderLineupSelection : constants.maxGeneralLineupSelection

    tablePlayers.forEach((p) => {
      // Only disable a player if the max selected is met, and the player isn't selected yet
      if (e.currentTarget.checked && selectedRows >= maxPlayers && !p.selected){
        p.disabled = true;
      }
      // We are deselecting a row, so enable the rows 
      else {
        //isEnabled is true if the player is a sub and they have already played two games.
        if (p.isEnabled) {
          p.disabled = false;
        }
        else {
          p.disabled = true;
        }
      }
    });

    leagueType === constants.pages.genderLeagues ? setGenderPlayers(newPlayers) : setPlayers(newPlayers);
  }

  const toggleSwapButton = (team) => {
    if (leagueType === constants.pages.localLeagues) return false;
    if (loggedInUser === "" || loggedInUser === constants.both) return false;
    // You can only swap when the lineup is locked
    return isLineupLocked && loggedInUser===team
  }

  const onSwapButtonClicked = (player) => {
    setIsSwapping(true);
    setSwappingPlayer(player);
  }

  const cancelClicked = () => {
    setIsSwapping(false);
    setSwappingPlayer({});
  }

  // Remove only happens once the match has started. We need to remove the player only where 
  // they haven't played yet.
  const removePlayer = (playerId) => {
    const PLAYER_FIELDS = [
      constants.homePlayer1,
      constants.homePlayer2,
      constants.awayPlayer1,
      constants.awayPlayer2,
    ];
    updateDirtyGames((prevGames) =>
      prevGames.map((game) => {
        const hasScore = game.homeScore != null && game.awayScore != null;
        if (hasScore) return game;

        const updatedGame = { ...game };
        let changed = false;

        PLAYER_FIELDS.forEach((field) => {
          if (updatedGame[field] === playerId) {
            updatedGame[field] = null;
            changed = true;
          }
        });

        return changed ? updatedGame : game;
      })
    );
    setIsSwapping(false);
    //const setPlayerState = leagueType === constants.pages.genderLeagues ? setGenderPlayers : setPlayers;

    // setPlayerState((prev) => {
    //   const updated = { ...prev };

    //   Object.keys(updated).forEach((category) => {
    //     updated[category] = updated[category].map((player) =>
    //       player[constants.playerId] === playerId
    //         ? { ...player, selected: false }
    //         : player
    //     );
    //   });

    //   return updated;
    // });
  };

  const replacePlayer = (newPlayer) => {
    const playerFields = [constants.homePlayer1, constants.homePlayer2, constants.awayPlayer1, constants.awayPlayer2];

    const newGames = dirtyGames.map((game) => {
      const updatedGame = { ...game };

      playerFields.forEach((field) => {
        if (updatedGame[field] === swappingPlayer[constants.playerId]) {
          updatedGame[field] = newPlayer;
        }
      });

      return updatedGame;
    });

    const changedFields = dirtyGames.reduce((acc, item, index) => {
      const other = newGames[index];
      if (!other) return acc;

      const fields = {};
      Object.keys(item).forEach((key) => {
        if (item[key] !== other[key]) fields[key] = (typeof other[key] == 'number' ? other[key].toString() : other[key]);
      });

      if (Object.keys(fields).length > 0) acc.push({ gameNumber: item.gameNumber, fields });
      return acc;
    }, []);

    cleanSwap(newGames, changedFields);
  }

  const cleanSwap = async (newGames, changedFields) => {
    setIsLoading(true);
    const url = constants.uri.matchup(newGames[0][constants.matchupId]);
    const request = {};
    request[constants.loginCode] = loggedInUser;
    request[constants.lineups] = changedFields;
    try {
      const baseUrl = utils.getBaseUrl(leagueType);

      const submitResponse = await api.patch(
        baseUrl,
        url,
        JSON.stringify(request),
      );

      if (submitResponse.hasOwnProperty('errors') && submitResponse.errors != null) {
        setDialog({
          title: submitResponse.errors.split(".")[0],
          code: "N/A",
          message: {message:submitResponse.errors.split(".")[1]},
          isError: true
        });
      }
      else if (submitResponse.errors != null) throw submitResponse;

      // Now that the save completed, set the "default" data so it matches the backened
      updateDirtyGames(newGames);
      setIsSwapping(false);
      setSwappingPlayer({});
      //re-render parent
      handleCleanSwap();
      setIsLoading(false);
    }
    catch (err) {
      console.error(err);
      setDialog({
        title: err.title ? err.title : constants.messages.errorMessage, 
        code: err.status ? err.status : "N/A", 
        message: err.message, 
        isError: true});
      setIsSwapping(false);
      setSwappingPlayer({});
      setIsLoading(false);
    }
  }

  const GenderRosterTables = () => {
     return (
      <Fragment>
        <div className={styles.GenderRow}>
          <div className={styles.TableTitle} style={{background: `${awayTeam.color}`}}>
            {awayTeam.name} <img src={`/logos/${awayTeam.logo}.png`} style={{height:'32px', width: '32px', marginLeft:'1em'}}/>
          </div>
          <div className={styles.TableContainer}>
            <div className={styles.TableSubtitle}></div>
            <div className={styles.Table} style={{borderRight: `1px solid ${constants.colors.cplNavy}`}}>
                <SelectTable
                  headers={constants.table.rosterCols} 
                  tableKeys={constants.playerId} 
                  tableData={genderPlayers.awayPlayers}
                  selectRow={onRowSelect}
                  canSelect={true}
                  showSwapButton={toggleSwapButton(constants.away)}
                  onSwapButtonClicked={onSwapButtonClicked}
                  isSwapping={isSwapping}
                  swappingPlayer={swappingPlayer}
                  replacePlayer={replacePlayer}
                  removePlayer={removePlayer}
                  isLineupLocked={isLineupLocked}
                  matchupTime={matchupTime}
                  matchupEnded={matchupEnded}/>
            </div>
          </div>
        </div>

        <div className={styles.GenderRow}>
          <div className={styles.TableTitle} style={{background: `${homeTeam.color}`}}>
              {homeTeam.name} <img src={`/logos/${homeTeam.logo}.png`} style={{height:'32px', width: '32px', marginLeft:'1em'}}/>
          </div>
          <div className={styles.TableContainer}>
            <div className={styles.TableSubtitle}></div>
            <div className={styles.Table} style={{borderRight: `1px solid ${constants.colors.cplNavy}`}}>
                <SelectTable
                  headers={constants.table.rosterCols} 
                  tableKey={constants.playerId}
                  tableData={genderPlayers.homePlayers}
                  selectRow={onRowSelect}
                  canSelect={true}
                  showSwapButton={toggleSwapButton(constants.home)}
                  onSwapButtonClicked={onSwapButtonClicked}
                  isSwapping={isSwapping}
                  swappingPlayer={swappingPlayer}
                  replacePlayer={replacePlayer}
                  removePlayer={removePlayer}
                  isLineupLocked={isLineupLocked}
                  matchupTime={matchupTime}
                  matchupEnded={matchupEnded}/>
            </div>
          </div>
        </div>
      </Fragment>
    );   
  }

  const RosterTables = () => {
    return (
      <Fragment>
        <div className={styles.GenderRow}>
          <div className={styles.TableTitle} style={{background: `${awayTeam.color}`}}>
            {awayTeam.name} <img src={`/logos/${awayTeam.logo}.png`} style={{height:'32px', width: '32px', marginLeft:'1em'}}/>
          </div>
          <div className={styles.TableContainer}>
            <div className={styles.Table} style={{borderRight: `1px solid ${constants.colors.cplNavy}`}}>
              <div className={styles.TableSubtitle}>Women</div>
                <SelectTable
                  headers={constants.table.rosterCols} 
                  tableKeys={constants.playerId} 
                  tableData={players.awayFemales}
                  selectRow={onRowSelect}
                  canSelect={leagueType === constants.pages.leagues}
                  showSwapButton={toggleSwapButton(constants.away)}
                  onSwapButtonClicked={onSwapButtonClicked}
                  isSwapping={isSwapping}
                  swappingPlayer={swappingPlayer}
                  replacePlayer={replacePlayer}
                  removePlayer={removePlayer}
                  isLineupLocked={isLineupLocked}
                  matchupTime={matchupTime}
                  matchupEnded={matchupEnded}/>
            </div>
            <div className={styles.Table}>
              <div className={styles.TableSubtitle}>Men</div>
                <SelectTable
                  headers={constants.table.rosterCols} 
                  tableKey={constants.playerId}
                  tableData={players.awayMales}
                  selectRow={onRowSelect}
                  canSelect={leagueType === constants.pages.leagues}
                  showSwapButton={toggleSwapButton(constants.away)}
                  onSwapButtonClicked={onSwapButtonClicked}
                  isSwapping={isSwapping}
                  swappingPlayer={swappingPlayer}
                  replacePlayer={replacePlayer}
                  removePlayer={removePlayer}
                  isLineupLocked={isLineupLocked}
                  matchupTime={matchupTime}
                  matchupEnded={matchupEnded}/>
            </div>
          </div>
        </div>

        <div className={styles.GenderRow}>
          <div className={styles.TableTitle} style={{background: `${homeTeam.color}`}}>
              {homeTeam.name} <img src={`/logos/${homeTeam.logo}.png`} style={{height:'32px', width: '32px', marginLeft:'1em'}}/>
          </div>
          <div className={styles.TableContainer}>
            <div className={styles.Table} style={{borderRight: `1px solid ${constants.colors.cplNavy}`}}>
              <div className={styles.TableSubtitle}>Women</div>
                <SelectTable
                  headers={constants.table.rosterCols} 
                  tableKey={constants.playerId}
                  tableData={players.homeFemales}
                  selectRow={onRowSelect}
                  canSelect={leagueType === constants.pages.leagues}
                  showSwapButton={toggleSwapButton(constants.home)}
                  onSwapButtonClicked={onSwapButtonClicked}
                  isSwapping={isSwapping}
                  swappingPlayer={swappingPlayer}
                  replacePlayer={replacePlayer}
                  removePlayer={removePlayer}
                  isLineupLocked={isLineupLocked}
                  matchupTime={matchupTime}
                  matchupEnded={matchupEnded}/>
            </div>
            <div className={styles.Table}>
              <div className={styles.TableSubtitle}>Men</div>
                <SelectTable
                  headers={constants.table.rosterCols} 
                  tableKey={constants.playerId}
                  tableData={players.homeMales}
                  selectRow={onRowSelect}
                  canSelect={leagueType === constants.pages.leagues}
                  showSwapButton={toggleSwapButton(constants.home)}
                  onSwapButtonClicked={onSwapButtonClicked}
                  isSwapping={isSwapping}
                  swappingPlayer={swappingPlayer}
                  replacePlayer={replacePlayer}
                  removePlayer={removePlayer}
                  isLineupLocked={isLineupLocked}
                  matchupTime={matchupTime}
                  matchupEnded={matchupEnded}/>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  return (
    <div className={styles.Rosters}>
      {isSwapping ? 
      <div className={styles.SwapBanner}>
        <div className={styles.SwapBannerLeft}>
          <div className={styles.SwapBannerHeader}>{`Swapping out ${swappingPlayer[constants.firstName]} ${swappingPlayer[constants.lastName]}`}</div>
          <div className={styles.SwapBannerText}>Choose a replacement below, or remove them without a direct replacement.</div>
          <div className={styles.SwapBannerText} style={{fontWeight: '700'}}>If you remove a player, you MUST replace them on the scorecard.</div>
        </div>
        <button className={styles.CancelButton} onClick={cancelClicked}>Cancel</button>

      </div> : <></>}
      {leagueType === constants.pages.genderLeagues ? <GenderRosterTables/> : <RosterTables/>}
    </div>
  )
}

export default Rosters;